<template>
  <div v-if="report">
    <div class="visit-meta">
      <h3>End of Day Report</h3>
    </div>
    <vs-breadcrumb class="mt-2">
      <li>
        <router-link to="/lists">Lists</router-link>
        <span class="vs-breadcrum--separator">/</span>
      </li>
      <li>
        EOD Reports
        <span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="active">
        {{ moment(report.date).format("LL") }}
      </li>
    </vs-breadcrumb>
    <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none mt-8" id="profile-tabs" :key="isSmallerScreen">
      <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'General' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <eod-report-general :report="report" />
        </div>
      </vs-tab>

      <!-- INFO -->
      <vs-tab icon-pack="feather" icon="icon-hash" :label="!isSmallerScreen ? 'Numbers' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0"></div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-file-text" :label="!isSmallerScreen ? 'Preview' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <eod-report-preview :report="report" />
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-alert-triangle" :label="!isSmallerScreen ? 'Danger Zone' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <eod-report-danger-zone :report="report" />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

import EodReportGeneral from "./EodReportGeneral.vue";
import EodReportPreview from "./EodReportPreview.vue";
import EodReportDangerZone from "./EodReportDangerZone.vue";

export default {
  components: {
    EodReportGeneral,
    EodReportPreview,
    EodReportDangerZone
  },
  data() {
    return {
      moment,
      reportId: null
    };
  },
  methods: {
    /*getItem: function () {
      

      
    },*/
  },
  computed: {
    ...mapGetters({
      report: "eodReports/eodReport"
    }),
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    }
    // questions() {
    //   return this.visit.modules[0].lessons[0].questions;
    // },
    // answers() {
    //   return this.visit.answers;
    // },
    // isComplete() {
    //   return this.visit.percentageComplete === 100;
    // },
  },
  async created() {
    this.reportId = this.$route.params.id;
    this.$vs.loading();
    await this.$store.dispatch("eodReports/getEodReport", this.reportId);
    console.log(this.reportId, this.eodReport);
    this.$vs.loading.close();
  }
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>